import { CardBody, StatHelpText, StatLabel, Heading, Flex, Text, VStack, Stat, StatNumber, Button, Tooltip } from "@chakra-ui/react"
import { Card } from "@chakra-ui/react"
import { Box } from "@chakra-ui/react"
import { SidebarInset } from "src/components/ui/sidebar"
import { SidebarProvider } from "src/components/ui/sidebar"
import SelectedRequests from "./selected-requests"
import RequestDetails from "./request-details/request-details"
import { updateActiveStep } from "src/redux/providerBuilder/stepperDetails"
import { useLocation, useNavigate } from "react-router-dom"
import { getAppType } from "src/redux/appBuilder/stepperDetails/selectors"
import { useAppDispatch, useAppSelector } from "src/redux/hooks"
import { getSelectedInstances } from "src/redux/providerBuilder/selectedInstances/selectors"
import { getActiveStep } from "src/redux/providerBuilder/stepperDetails/selectors"
import { useState } from "react"
import { getSelectedNetworkRequest } from "src/redux/providerBuilder/selectedNetworkRequest/selectors"

const RequestDataSelection = (
    {
        searchText,
        setActiveStepInnerForm
    }: {
        searchText: any,
        setActiveStepInnerForm: (value: any) => void
    }
) => {
    const location = useLocation();
    const { manualVerificationFlow, sessionId } = location.state ?? {};
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(location.search);
    const isEdit = searchParams.get('isEdit');
  const appType = useAppSelector(getAppType);
  const selectedInstances = useAppSelector(getSelectedInstances);
  const activeStep = useAppSelector(getActiveStep);
  const dispatch = useAppDispatch();
  const [buttonLoading, setButtonLoading] = useState(false);

  const getAllSelectedRequest = useAppSelector(getSelectedNetworkRequest);

    function handleGoBack() {
        if (manualVerificationFlow) {
          navigate('/manual-verification', {
            state: { manualVerificationFlow: true, sessionId },
          });
        } else if (isEdit) {
          navigate(-1);
        }
        if (appType === 'ZK_FETCH') setActiveStepInnerForm(2);
        else setActiveStepInnerForm(0);
      }

    function handleDisableNextButton() {
      // Check if there are any selected requests
      if (!getAllSelectedRequest?.length) return true;

      // Create a map of request indices that have instances
      const requestIndicesWithInstances = new Set(
        selectedInstances.map(instance => instance.responseSelection.requestIndex)
      );

      // Check if each request has at least one instance
      for (let i = 0; i < getAllSelectedRequest.length; i++) {
        if (!requestIndicesWithInstances.has(i)) {
          return true; // Disable button if any request lacks an instance
        }
      }
      return !selectedInstances.length;
    }

    return (
        <Box maxW="1400px" margin="auto">
            <div className="relative overflow-hidden border h-[85vh] rounded-lg">
                <SidebarProvider>
                    <SelectedRequests />
                    <SidebarInset>
                        <main className="h-[85vh] relative">
                            <div className="overflow-y-auto h-[calc(85vh-70px)]">
                                <RequestDetails searchText={searchText} />
                            </div>
                            <Box 
                                position="absolute"
                                bottom={0}
                                right={0}
                                left={0}
                                className="bg-secondary border-t border-gray-200"
                                px={30} 
                                py={4}
                                width="inherit"


                            >
                                <Flex w="full" justifyContent="space-between">
                                    <Button
                                        onClick={handleGoBack}
                                        backgroundColor="transparent"
                                        border="1px solid gray"
                                        borderRadius={10}
                                        minWidth={'100px'}
                                        fontWeight="normal"
                                        _hover={{
                                            fontWeight: 'bold',
                                        }}
                                    >
                                        Back
                                    </Button>
                                    <Flex alignItems="center" gap={3}>
                                        {appType !== 'ZK_FETCH' && (
                                            <Text color="gray.500" className="small-font">
                                                3/7
                                            </Text>
                                        )}
                                        <Tooltip
                                            label={
                                                selectedInstances.length
                                                    ? ''
                                                    : 'Please add at least one data instance to proceed'
                                            }
                                        >
                                            <Button
                                                backgroundColor="black"
                                                color="white"
                                                border="1px solid black"
                                                borderRadius={10}
                                                fontWeight="normal"
                                                _hover={{ backgroundColor: 'gray.800' }}
                                                isLoading={buttonLoading}
                                                minWidth={'100px'}
                                                isDisabled={handleDisableNextButton()}
                                                onClick={() => {
                                                    setButtonLoading(true);
                                                    if (appType === 'ZK_FETCH') {
                                                        setActiveStepInnerForm(5);
                                                        return;
                                                    }
                                                    dispatch(updateActiveStep(activeStep + 1));
                                                }}
                                            >
                                                Next
                                            </Button>
                                        </Tooltip>
                                    </Flex>
                                </Flex>
                            </Box>
                        </main>
                    </SidebarInset>
                </SidebarProvider>
            </div>
        </Box>
    )
}

const StatsCard = ({ title, value, description }: { title: string, value: string, description: string }) => {
    return (
        <Card variant="outline" flex={1} borderRadius={10} height="fit-content">
            <CardBody pl={4} pb={2}>
                <Stat>
                    <StatLabel
                        mb={1}
                        className="medium-font"
                        color="#667085"
                        fontWeight={600}
                    >
                        {title}
                    </StatLabel>
                    <StatNumber>
                        <Flex alignItems="center" gap={2}>
                            <Text className="large-font">{value}</Text>
                        </Flex>
                    </StatNumber>
                    <StatHelpText
                        mt={1}
                        fontWeight={400}
                        className="x-small-font"
                        color="gray.600"
                    >
                        {description}
                    </StatHelpText>
                </Stat>
            </CardBody>
        </Card>
    )
}

export default RequestDataSelection
